module.exports = __webpack_public_path__ + "static/media/splash_video.cec6fbba.mp4";